<template>
  <div class="flex flex-col gap-sm pb-sm">
    <div class="text-center" v-if="arendeStore.arenden.isLoading">
      <SmallSpinner />
    </div>
    <div id="no-arenden-message" class="rounded bg-avtalat-gray p-sm" v-if="!arendeStore.hasArenden">
      Det finns inga tidigare ärenden
    </div>
    <template v-if="!arendeStore.arenden.isLoading && arendeStore.hasArenden">
      <ArendenList id="open-arenden-list" heading="Öppna ärenden" :arenden="arendeStore.openArenden" />
      <ArendenList
        id="closed-arenden-list"
        heading="Stängda ärenden"
        :arenden="arendeStore.closedArenden"
      />
    </template>
  </div>
</template>

<script setup lang="ts">
import ArendenList from "@/components/arende-components/ArendenList.vue";
import SmallSpinner from "@/components/ui/SmallSpinner.vue";

import { useAnstalldarendeStore } from "../store";

const arendeStore = useAnstalldarendeStore();
</script>
